export default __webpack_public_path__ + "static/media/error-circle.4d60ee11.svg";